import { configureStore } from '@reduxjs/toolkit'
import iaamSlice from './iaamSlice'
import drgMgtSlice from './drgMgtSlice'
import openRightSideSlice from './openRightSideSlice'
import attributeSelectionSlice from './attributeSelectionSlice'
import regulatoryFileSlice from './regulatoryFileSlice'
import dpesSlice from './dpesSlice'
import selectedNodeSlice from './selectedNodeSlice'
import regulatoryFileActionSlice from './regulatoryFileActionSlice'
import openPreviewDRGSlice from './openPreviewDRGSlice'
import openSimulatorDRGSlice from './openSimulatorDRGSlice'
import previewDRGDataSlice from './previewDRGDataSlice'
import snackbarMessageSlice from './snackbarMessageSlice'
import previewCurrentSlice from './previewCurrentSlice'
import hasDiagramChangeSlice from './hasDiagramChangeSlice'
import hasFileChangeSlice from './hasFileChangeSlice'
import allDRGInProjectSlice from './allDRGInProjectSlice'
import subjectSchemaSlice from './subjectSchemaSlice'
import clientsSlice from './clientsSlice'
import drgValidationSlice from './drgValidationSlice'
import clickNextFileSlice from './clickNextFileSlice'
import simulatorProfilesSlice from './simulatorProfilesSlice'
import selectedProfileSimulateSlice from './selectedProfileSimulateSlice'
import dataSourceSimulateSlice from './dataSourceSimulateSlice'
import statementOptionsSlice from './statementOptionsSlice'
import statementHighlightPathsSlice from './statementHighlightPathsSlice'
import selectedStatementSlice from './selectedStatementSlice'
import usedParametersInDiagramSlice from './usedParametersInDiagramSlice'
import openSimulatorPolicySlice from './openSimulatorPolicySlice'
import selectedProfilesPolicySimulatorSlice from './selectedProfilesPolicySimulator'

export const store = configureStore({
  reducer: {
    iaamContext: iaamSlice,
    drgMgt: drgMgtSlice,
    openRightSide: openRightSideSlice,
    attributeSelection: attributeSelectionSlice,
    regulatoryFile: regulatoryFileSlice,
    dpeRedux: dpesSlice,
    selectedNode: selectedNodeSlice,
    regulatoryFileAction: regulatoryFileActionSlice,
    openPreviewDRG: openPreviewDRGSlice,
    openSimulatorDRG: openSimulatorDRGSlice,
    previewDRGData: previewDRGDataSlice,
    snackbarMessage: snackbarMessageSlice,
    previewCurrent: previewCurrentSlice,
    hasDiagramChange: hasDiagramChangeSlice,
    hasFileChange: hasFileChangeSlice,
    allDRGInProject: allDRGInProjectSlice,
    subjectSchema: subjectSchemaSlice,
    clients: clientsSlice,
    drgValidation: drgValidationSlice,
    clickNextFile: clickNextFileSlice,
    simulatorProfiles: simulatorProfilesSlice,
    selectedProfileSimulate: selectedProfileSimulateSlice,
    dataSourceSimulate: dataSourceSimulateSlice,
    statementOptions: statementOptionsSlice,
    statementHighlightPaths: statementHighlightPathsSlice,
    selectedStatement: selectedStatementSlice,
    usedParametersInDiagram: usedParametersInDiagramSlice,
    openSimulatorPolicy: openSimulatorPolicySlice,
    selectedProfilesPolicySimulator: selectedProfilesPolicySimulatorSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
})